import { USER_ACTION_TYPES, COMMON_ACTION_TYPES } from "../../_constants";

const INITIAL_STATE = {
    userDetail: {
        isLoading: false,
        data: [],
    },
    userList: {
        isLoading: false,
        data: [],
    },
    roleList: {
        isLoading: false,
        data: [],
    },
    createUser: {
        isProcessing: false,
        data: [],
    },
    assignUserRole: {
        isProcessing: false,
        data: [],
    },
    assignUserFactories: {
        isProcessing: false,
        data: [],
    }
};
const userReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // GET USER Detail
        case USER_ACTION_TYPES.GET_USER_DETAIL + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                userDetail: {
                    isLoading: true,
                    data: [],
                }
            };
        case USER_ACTION_TYPES.GET_USER_DETAIL + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                userDetail: {
                    isLoading: false,
                    data: action.data,
                }
            };

        case USER_ACTION_TYPES.GET_USER_DETAIL + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                userDetail: {
                    isLoading: false,
                    data: [],
                }
            };
        // GET USER LIST
        case USER_ACTION_TYPES.GET_USER_LIST + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                userList: {
                    isLoading: true,
                    data: [],
                }
            };

        case USER_ACTION_TYPES.GET_USER_LIST + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                userList: {
                    isLoading: false,
                    data: action.data
                }
            };

        case USER_ACTION_TYPES.GET_USER_LIST + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                userList: {
                    isLoading: false,
                    data: []
                }
            };

        //    GET USER ROLE LIST
        case USER_ACTION_TYPES.GET_USER_ROLE_LIST + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                roleList: {
                    isLoading: true,
                    data: [],
                }
            };

        case USER_ACTION_TYPES.GET_USER_ROLE_LIST + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                roleList: {
                    isLoading: false,
                    data: action.data
                }
            };

        case USER_ACTION_TYPES.GET_USER_ROLE_LIST + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                roleList: {
                    isLoading: false,
                    data: []
                }
            };

        //    CREATE NEW USER
        case USER_ACTION_TYPES.CREATE_USER + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                createUser: {
                    isProcessing: true,
                    data: [],
                }
            };

        case USER_ACTION_TYPES.CREATE_USER + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                createUser: {
                    isProcessing: false,
                    data: action.data
                }
            };

        case USER_ACTION_TYPES.CREATE_USER + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                createUser: {
                    isProcessing: false,
                    data: [],
                }
            };

        //    ASSIGN USER ROLES
        case USER_ACTION_TYPES.ASSIGN_USER_ROLES + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                assignUserRole: {
                    isProcessing: true,
                    data: [],
                }
            };

        case USER_ACTION_TYPES.ASSIGN_USER_ROLES + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                assignUserRole: {
                    isProcessing: false,
                    data: action.data
                }
            };

        case USER_ACTION_TYPES.ASSIGN_USER_ROLES + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                assignUserRole: {
                    isProcessing: false,
                    data: []
                }
            };

        //    ASSIGN USER FACTORIES
        case USER_ACTION_TYPES.ASSIGN_USER_FACTORIES + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                assignUserFactories: {
                    isProcessing: true,
                    data: [],
                }
            };

        case USER_ACTION_TYPES.ASSIGN_USER_FACTORIES + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                assignUserFactories: {
                    isProcessing: false,
                    data: action.data
                }
            };
        case USER_ACTION_TYPES.ASSIGN_USER_FACTORIES + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                assignUserFactories: {
                    isProcessing: false,
                    data: []
                }
            };
        default:
            return state;
    }
}

export default userReducer;
